import React from "react";
import { TextField } from "@finpay-development/shared-components";
import { Grid, MenuItem } from "@mui/material";
import { FormSectionProps } from "../types";
import "../../../../tab-styling.scss"

export const PersonalInfoSection: React.FC<FormSectionProps> = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
}) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={1.5}>
                <TextField
                    select
                    className={`state-field ${touched.title && Boolean(errors.title) ? 'error-border' : ""}`}
                    name="title"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Title"
                    placeholder="Select"
                    error={Boolean(touched.title && errors.title)}
                    helperText={touched.title && errors.title ? String(errors.title) : undefined}
                >
                    <MenuItem value="Mr.">Mr.</MenuItem>
                    <MenuItem value="Ms.">Ms.</MenuItem>
                    <MenuItem value="Mrs.">Mrs.</MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={3}>
                <TextField
                    name="preferredName"
                    placeholder="Preferred Name"
                    value={values.preferredName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Preferred Name"
                    className={`${touched.preferredName && Boolean(errors.preferredName) ? 'error-border' : ""}`}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    name="firstName"
                    placeholder="First Name"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="First Name"
                    className={`state-field ${touched.firstName && Boolean(errors.firstName) ? 'error-border' : 'required-fields'}`}
                    required
                    test-id="patient-tab-first-name"
                />
            </Grid>
            <Grid item xs={1.5}>
                <TextField
                    name="middleName"
                    placeholder="MI"
                    value={values.middleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="M.I."
                    helperText={touched.middleName && errors.middleName ? String(errors.middleName) : undefined}
                    className={`${touched.middleName && Boolean(errors.middleName) ? 'error-border' : ""}`}
                    maxLength={1}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    name="lastName"
                    placeholder="Last Name"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Last Name"
                    className={`state-field ${touched.lastName && Boolean(errors.lastName) ? 'error-border' : 'required-fields'}`}
                    required
                    test-id="patient-tab-last-name"
                />
            </Grid>
        </Grid>
    );
}; 